<template>
  <label :class="wrapperClasses">
    <input
      :name="name"
      type="radio"
      :value="value"
      :checked="isChecked"
      :disabled="disabled"
      @change="onChange"
    />

    <span :class="controlClasses">
      <span :class="style.dot" />
    </span>

    <span v-if="text || $slots.default" :class="style.text">
      <slot>
        {{ text }}
      </slot>
    </span>
  </label>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "./RadioButton.module.scss";

export default defineComponent({
  name: "RadioButton",
  emits: ["update:modelValue", "change"],
  props: {
    modelValue: {
      type: [String, Number, Boolean, Object, null] as PropType<CheckboxValue>,
      default: null
    },
    value: {
      type: [String, Number, Boolean, Object] as PropType<CheckboxValue>,
      required: true
    },
    text: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String as PropType<Size>,
      default: "M"
    }
  },

  data() {
    return {
      style
    };
  },

  computed: {
    isChecked(): boolean {
      return this.modelValue === this.value;
    },

    wrapperClasses(): string[] {
      return [
        style.radioButton,
        style[`size${this.size}`],
        this.disabled ? style.disabled : ""
      ];
    },

    controlClasses(): string[] {
      return [style.control, this.isChecked ? style.controlChecked : ""];
    }
  },

  methods: {
    onChange(): void {
      if (this.disabled) {
        return;
      }

      this.$emit("update:modelValue", this.value);
      this.$emit("change", this.value);
    }
  }
});
</script>
